import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const target = req.headers.get('x-target') ?? '';
  const port = req.headers.get('x-port') ?? '8080';

  let isLocal = false;
  if (typeof window !== 'undefined') {
    isLocal = window?.location?.hostname ? window.location.hostname === 'localhost' : false;
  }

  const delimiter = req.url.includes('?') ? '&' : '?';
  const timestamp = new Date().toISOString();

  const apiReq =
    target === 'external'
      ? req
      : target === 'localhost' && isLocal
        ? req.clone({
            url: `http://localhost:${port}${req.url}${delimiter}t=${timestamp}`,
          })
        : req.clone({
            url: `${environment.apiBaseUrl}${req.url}${delimiter}t=${timestamp}`,
          });

  return next(apiReq);
};
